import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ChevronDown, GitBranch, Globe, LogOut, Trash2, UserRound, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { ASSETS } from "@/lib/assets";

export const AppShell = ({ children, wide }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [trashCount, setTrashCount] = useState(0);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    api.get("/projects/trash").then((r) => setTrashCount(r.data.length)).catch(() => {});
  }, []);
  const link = ({ isActive }) => `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-slate-100 text-[var(--ink)]" : "text-slate-600 hover:text-[var(--ink)]"}`;
  return (
    <div className="min-h-screen bg-white">
      <header data-testid="app-header" className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className={`mx-auto ${wide ? "max-w-[1600px]" : "max-w-7xl"} px-5 h-16 flex items-center justify-between gap-6`}>
          <div className="flex items-center gap-6">
            <Link to="/app" data-testid="app-logo"><img src={ASSETS.logo} alt="Lowpages" className="h-7" /></Link>
            <nav className="hidden sm:flex items-center gap-1">
              <NavLink to="/app" end className={link} data-testid="nav-projects">Projetos</NavLink>
              <NavLink to="/app/leads" className={link} data-testid="nav-leads"><span className="flex items-center gap-1.5"><Users size={14} /> Leads</span></NavLink>
              <NavLink to="/app/funnels" className={link} data-testid="nav-funnels"><span className="flex items-center gap-1.5"><GitBranch size={14} /> Funis</span></NavLink>
              <NavLink to="/app/domains" className={link} data-testid="nav-domains"><span className="flex items-center gap-1.5"><Globe size={14} /> Domínios</span></NavLink>
              <NavLink to="/app/trash" className={link} data-testid="nav-trash"><span className="flex items-center gap-1.5"><Trash2 size={14} /> Lixeira {trashCount > 0 && <span className="rounded-full bg-slate-200 px-1.5 text-[10px] font-mono">{trashCount}</span>}</span></NavLink>
            </nav>
          </div>
          <div className="relative">
            <button data-testid="user-menu-button" onClick={() => setOpen(!open)} className="flex items-center gap-2 rounded-full border border-slate-200 pl-1.5 pr-3 py-1.5 text-sm hover:bg-slate-50">
              {user.picture ? <img src={user.picture} alt="" className="h-7 w-7 rounded-full" /> : <span className="h-7 w-7 rounded-full bg-[var(--blue)] text-white grid place-items-center text-xs font-bold">{(user.name || user.email)[0].toUpperCase()}</span>}
              <span className="hidden sm:inline max-w-[180px] truncate">{user.email}</span>
              <ChevronDown size={14} className="text-slate-400" />
            </button>
            {open && (
              <div data-testid="user-menu" className="absolute right-0 mt-2 w-56 rounded-xl border border-slate-200 bg-white shadow-xl p-1.5 text-sm" onMouseLeave={() => setOpen(false)}>
                <button data-testid="user-menu-account" onClick={() => { setOpen(false); nav("/app/account"); }} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-50"><UserRound size={14} /> Minha conta</button>
                <button data-testid="user-menu-logout" onClick={async () => { await logout(); nav("/login"); }} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-slate-50 text-red-600"><LogOut size={14} /> Sair</button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className={`mx-auto ${wide ? "max-w-[1600px]" : "max-w-7xl"} px-5 py-8`}>{children}</main>
    </div>
  );
};

export const Thumb = ({ html, className = "" }) => (
  <div className={`relative overflow-hidden bg-slate-100 ${className}`}>
    <iframe title="preview" srcDoc={html} sandbox="" loading="lazy" scrolling="no" tabIndex={-1} className="absolute left-0 top-0 origin-top-left pointer-events-none border-0" style={{ width: 1280, height: 900, transform: "scale(var(--thumb-scale, 0.25))" }} />
  </div>
);
